/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Ingredients_HelpInputs */

const en_editor_ingredients_help = /** @type {(inputs: Editor_Ingredients_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Amount, unit and ingredient; a note follows after a comma. Dishly splits whole lines like "200 g quark" itself, and pasted lines become separate ingredients.`)
};

const de_editor_ingredients_help = /** @type {(inputs: Editor_Ingredients_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menge, Einheit und Zutat; eine Notiz folgt nach einem Komma. Ganze Zeilen wie „200 g Quark“ teilt Dishly selbst auf, mehrere eingefügte Zeilen werden mehrere Zutaten.`)
};

/**
* | output |
* | --- |
* | "Amount, unit and ingredient; a note follows after a comma. Dishly splits whole lines like \"200 g quark\" itself, and pasted lines become separate ingredients." |
*
* @param {Editor_Ingredients_HelpInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const editor_ingredients_help = /** @type {((inputs?: Editor_Ingredients_HelpInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Ingredients_HelpInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_editor_ingredients_help(inputs)
	return en_editor_ingredients_help(inputs)
});